export default __webpack_public_path__ + "static/media/bikeshare.68ab9e0f.svg";